import React from "react";
import { useRouter } from "next/router";

import { SuccessfulPaymentModal } from "@/components/SuccessfulPaymentModal";
import { WelcomeAboardModal } from "@/components/WelcomeAboardModal";
import { usePricingContext } from "../state/context";

export const SuccessModal: React.FC = () => {
  const { current, send } = usePricingContext();
  const { push: redirect } = useRouter();
  const { newUser, userEmail } = current.context;

  const closeModal = () => {
    send({
      type: "CLOSE_MODAL",
    });
    userEmail && redirect("/account");
  };

  return newUser ? (
    <WelcomeAboardModal onClose={closeModal} />
  ) : (
    <SuccessfulPaymentModal onClose={closeModal} />
  );
};
